module.exports = __webpack_public_path__ + "img/indeximg3.56e5e0ba.png";